// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from "bootstrap-vue"
import App from './App'
import router from './router'

// Linguagem
import VueI18n from 'vue-i18n'
import { i18n } from './lang/i18n-core.js'

export { i18n }

import permissao from './mixins/permissao.js';
import axios from 'axios'

import Moment from 'moment'
import {DatePicker, Icon, Button, Dropdown, DropdownMenu, DropdownItem, Menu, Submenu, MenuItem, MenuItemGroup} from 'element-ui'
import * as Cookies from 'tiny-cookie'
import VueTheMask from 'vue-the-mask'
import money from 'v-money'
import VueChartkick from 'vue-chartkick'
import Highcharts from 'highcharts'
import VueSweetalert2 from 'vue-sweetalert2';
import dragscroll from "vue-dragscroll";
import otpInput from "@bachdgvn/vue-otp-input";

import enLang from 'element-ui/lib/locale/lang/en'
import ptLang from 'element-ui/lib/locale/lang/pt'
import locale from 'element-ui/lib/locale'

import './assets/vkbeautify.0.99.00.beta'
import helper from './assets/function.js'
import directive from './assets/directive.js'
import store from './store'

//import filter from './assets/filter.js'

const $ = require('./assets/jquery-3.2.1.min.js');
// We declare it globally
window.$ = $;

locale.use(enLang)

Vue.use(VueI18n)
Vue.use(BootstrapVue)

Vue.mixin(permissao);

//element
Vue.use(DatePicker)
Vue.use(Icon)
Vue.use(Button)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)

Vue.use(VueTheMask)
Vue.use(VueChartkick, {adapter: Highcharts})
Vue.use(VueSweetalert2)

Vue.use(dragscroll)
Vue.use(otpInput)

Vue.prototype.moment = Moment
Vue.use(money, {precision: 2,
				decimal: ',',
				thousands: '.',
				prefix: 'R$ ',
				masked: false})

/********************/
/* 	  DIRECTIVES 	*/
/********************/
Vue.use(directive);
Vue.directive('date_format', directive.date_format);
Vue.directive('timestamp_format', directive.timestamp_format);
Vue.directive('value_format', directive.value_format);






/********************/
/* 	  HELPER 	*/
/********************/
const plugin = {
	install(){
		Vue.helper = helper;
		Vue.prototype.$helper = helper;

		Vue.cookie = Cookies;
		Vue.prototype.$cookie = Cookies;
	}
}

Vue.use(plugin)

/**
 * Number.prototype.format(n, x, s, c)
 *
 * @param integer n: length of decimal
 * @param integer x: length of whole part
 * @param mixed   s: sections delimiter
 * @param mixed   c: decimal delimiter
 */
Number.prototype.format = function(n, x, s, c) {
	var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
		num = this.toFixed(Math.max(0, ~~n));

	return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
};





/********************/
/* 	  LINGUAGEM 	*/
/********************/
const loadedLanguages = ['en', 'pt'] // our default language that is prelaoded

function setI18nLanguage(lang){
	i18n.locale = lang
	axios.defaults.headers.common['Accept-Language'] = lang
	document.querySelector('html').setAttribute('lang', lang)
	return lang
}

export function loadLanguageAsync(lang){

	if(i18n.locale !== lang){

		if(lang == 'en'){
			locale.use(enLang);
		}else if(lang == 'pt'){
			locale.use(ptLang);
		}

		if(!loadedLanguages.includes(lang)){
			return import(/* webpackChunkName: "lang-[request]" */ `@/lang/${lang}`).then(msgs => {
				i18n.setLocaleMessage(lang, msgs.default)
				loadedLanguages.push(lang)
				return setI18nLanguage(lang)
			})
		}

		return Promise.resolve(setI18nLanguage(lang))
	}
	return Promise.resolve(lang)
}

String.prototype.replaceArray = function(find, replace) {
	var replaceString = this;
	var regex;
	for (var i = 0; i < find.length; i++) {
		regex = new RegExp(find[i], "g");
		replaceString = replaceString.replace(regex, replace[i]);
	}
	return replaceString;
};


Vue.prototype.$locale = {
	change (lang) {
		Vue.config.lang = lang;
		loadLanguageAsync(lang);
	},
	current () {
		return Vue.config.lang
	}
}

Vue.mixin({
	methods: {
		returnPercentByLang: function () {
			switch (this.$cookie.get('rep_format')) {
				case '1':
					return {
						decimal: ',',
						thousands: '.',
						prefix: '',
						suffix: '',
						precision: 2,
						masked: false
					};
					break;

				default:
					return {
						decimal: '.',
						thousands: ',',
						prefix: '',
						suffix: '',
						precision: 2,
						masked: false
					};
				break;
			}
		},
		auxNotifyChange: function(param, newVal, oldVal){

            let aux;

            if(this.start == 0){
                return;
            }

            if(newVal != oldVal){

                let type = $("#" + param).attr("type");
                if(type == 'radio'){
                    // Radio's estão em diferentes divs. Assim deve-se percorrer e atualizar todos os locais

                    $('input[name="' + param + '"]').each(function(){

                        aux = $(this).parents(".form-row").get(0);

                        if($(aux).hasClass("input-group-text")){
                            aux = $(aux).parents().get(1);
                        }

                        if(typeof aux == "undefined"){
                            aux = $("#" + param).parents("div.form-group").get(0);
                        }

                        if(typeof aux == "undefined"){
                            aux = $("#" + param).parents(".col").get(0);
                        }
						$(aux).removeClass("alert-danger");
                        $(aux).addClass("alert alert-warning");
                    });
                }else{
                    aux = $("#" + param).parents(".form-row").get(0);

                    if(typeof aux == "undefined"){
                        aux = $("#" + param).parents("div.form-group").get(0);
                    }

                    if(typeof aux == "undefined"){
                        aux = $("#" + param).parents(".col").get(0);
					}

					$(aux).removeClass("alert-danger");
                    $(aux).addClass("alert alert-warning");
                }
            }

			// identifica qual o elemento que está ativo, e adiciona uma classe, para destacar que houve alteração
			let tab = $("#" + param).parents("div.tab-content").get(0);
			let tab2 = $(tab).prev();
			let link = $(tab2).find("a.active").get(0);
			$(link).parent().addClass("alert-dark-warning");

            return;
		},
		errorNotifyInput: function(param, newVal, oldVal){

            let aux;

            if(this.start == 0){
                return;
            }

            if(newVal != oldVal){

                let type = $("#" + param).attr("type");
                if(type == 'radio'){
                    // Radio's estão em diferentes divs. Assim deve-se percorrer e atualizar todos os locais

                    $('input[name="' + param + '"]').each(function(){

                        aux = $(this).parents(".form-row").get(0);

                        if($(aux).hasClass("input-group-text")){
                            aux = $(aux).parents().get(1);
                        }

                        if(typeof aux == "undefined"){
                            aux = $("#" + param).parents("div.form-group").get(0);
                        }

                        if(typeof aux == "undefined"){
                            aux = $("#" + param).parents(".col").get(0);
                        }
						$(aux).removeClass("alert-warning");

                        $(aux).addClass("alert alert-danger");
                    });
                }else{
                    aux = $("#" + param).parents(".form-row").get(0);

                    if(typeof aux == "undefined"){
                        aux = $("#" + param).parents("div.form-group").get(0);
                    }

                    if(typeof aux == "undefined"){
                        aux = $("#" + param).parents(".col").get(0);
                    }
					$(aux).removeClass("alert-warning");

                    $(aux).addClass("alert alert-danger");
                }
            }

			// identifica qual o elemento que está ativo, e adiciona uma classe, para destacar que houve alteração
			let tab = $("#" + param).parents("div.tab-content").get(0);
			let tab2 = $(tab).prev();
			let link = $(tab2).find("a.active").get(0);
			$(link).parent().addClass("alert-dark-danger");

            return;
        }
	}
});

/********************/
/* 	  CONSTRUTOR 	*/
/********************/
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    router,
    helper,
    i18n,
    store,
	render: h => h(App)
}).$mount('#app');


